import { toObjectMap } from "@@/utilities/dictionary";

const swishPaymentStatusTypes = [
    "PENDING",
    "PAID",
    "DECLINED",
    "ERROR",
    "CANCELLED",
] as const;
type SwishPaymentStatusType = typeof swishPaymentStatusTypes[number];
const swishPaymentStatusType = toObjectMap<SwishPaymentStatusType>([
    ...swishPaymentStatusTypes,
]);

export type { SwishPaymentStatusType };
export { swishPaymentStatusType, swishPaymentStatusTypes };
